import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setActiveFeaturedSelection } from '../modules/active_featured_selection';
import { boxActionAccept } from '../modules/decline_box_book';
import { openDeclineModal, openFeaturedSelectionsModal }       from '../modules/active_modal';
import { navigate } from '../modules/high_level_actions';
import dateformat from 'dateformat';

class NegativeOptionCommerceBar extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let {dispatch, customer, tla}          = this.props,
            Featured                      = tla === "DVD" ? "Director's": "Featured",
            sFeaturedDeclineAction = <div><div>You do not need to respond to the {Featured} Selections.</div></div>;
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let replyByDate = new Date(this.props.customer.nanotime + ( (this.props.customer.current_cycle.days_left_to_respond - 1) * 24 * 60 * 60 * 1000));
        let shipDate = new Date(this.props.customer.current_cycle.ship_date);

        // Define Featured Selection items.
        let aFeaturedSelections = this.props.featured.slice(0,2).map(oProduct => {
            const hoverClass  = this.props.navigable ? "" : "shiny-hover ";
            const activeClass = parseInt( this.props.activeProduct.id, 10 ) === parseInt( oProduct.id, 10 ) ? "active" : "";
        let oEvent = {
            preventDefault: () => {/* noop */},
            currentTarget: {
                pathname: '/catalog/product/' + oProduct.id + '-' + oProduct.url
            }
        }


            return (
                <li
                    key       = {oProduct.id}
                    className = { hoverClass + activeClass}
                    onClick   = {() => dispatch( [setActiveFeaturedSelection( oProduct), openFeaturedSelectionsModal(), navigate(oEvent, false) ] )}
                >
                    <div className = "product-scaled-wrapper">
                        <img
                            className = "product-scaled"
                            src       = {'//s3.amazonaws.com/bookspan-media/covers/full/' + oProduct.mmid + '.jpg'}
                        />
                    </div>
                </li>
            );
        });

        // Set conditional CSS classNames and display text
        //@TODO condense all the checks for which section is active!!!
        let sFeaturedHeaderTxt = (this.props.path === '/' ? Featured + ' Selections' : 'View The ' + Featured + ' Selections');
        let sFeaturedActive    = (this.props.path === '/' ? 'active' : '');
        if(customer.fulfillment_type === "Negative"){
            if(customer.current_cycle.response === "active_decline")
                sFeaturedDeclineAction = (<div className="declined"><div>Thank you for responding. This confirms that you have declined your {Featured} Selection for {dateformat( replyByDate, "mmmm dS" )}.</div></div>);
            else if(customer.current_cycle.response === "active_accept")
                sFeaturedDeclineAction = (<div className="accepted"><div>You’ve accepted! Please checkout to complete your purchase of these items.</div></div>);
            else {
                if(customer.current_cycle.active)
                    sFeaturedDeclineAction = (
                        <div>
                            <div className="action">Please purchase or decline the {Featured} Selections by {dateformat( replyByDate, "mmmm dS" )}</div>
                            <button className="btn-primary" onClick={() => dispatch( boxActionAccept()) }>Accept</button>
                            <button className="btn-tertiary" onClick={() => dispatch( openDeclineModal() )}>Decline</button>
                        </div>
                    );
                else sFeaturedDeclineAction = (<div className="non-active"><div>You have {customer.current_cycle.days_until_next_cycle} days until the next cycle begins, and new box is unveiled.</div></div>);
            }
        }

        return (
            <div className={"half-col left " + sFeaturedActive}>
                <div className="inner-wrapper right">
                    <h6 className = {"header-link " + sFeaturedActive} >
                        {sFeaturedHeaderTxt}
                    </h6>
                    <div className="feature-selections-wrapper negative-option">
                        <ul>
                            {aFeaturedSelections}
                            <li className="decline">
                                {sFeaturedDeclineAction}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>);
    }
}


function mapStateToProps(state){
    return {
        'featured': state.featured,
        'tla': state.store.tla,
        'activeProduct': state.activeProduct,
        'customer': state.customer,
        'path': state.path,
    };
}

export default connect(mapStateToProps)(NegativeOptionCommerceBar);



// WEBPACK FOOTER //
// ./src/components/NegativeOptionCommerceBar.jsx